module.exports = __webpack_public_path__ + "static/10-e79e7d5aa603dbfe3ea07a375f923830.jpg";